var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66667 3.83333H4.79167C4.26239 3.83333 3.83333 4.26239 3.83333 4.79167V7.66667H0.958333C0.42906 7.66667 0 8.09573 0 8.625V22.0417C0 22.5709 0.42906 23 0.958333 23H14.375C14.9043 23 15.3333 22.5709 15.3333 22.0417V19.1667H18.2083C18.7376 19.1667 19.1667 18.7376 19.1667 18.2083V15.3333H22.0417C22.5709 15.3333 23 14.9043 23 14.375V0.958333C23 0.42906 22.5709 0 22.0417 0H8.625C8.09573 0 7.66667 0.42906 7.66667 0.958333V3.83333ZM8.9125 3.83333H18.2083C18.7376 3.83333 19.1667 4.26239 19.1667 4.79167V14.0875H21.7542V1.24583H8.9125V3.83333ZM14.375 7.66667H5.07917V5.07917H17.9208V17.9208H15.3333V8.625C15.3333 8.09573 14.9043 7.66667 14.375 7.66667ZM1.24583 8.9125V21.7542H14.0875V8.9125H1.24583Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer);
export default __webpack_public_path__ + "static/media/layer.c738b17949bec9b555e429088bf68e5d.svg";
export { ForwardRef as ReactComponent };